import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import OptionListDialog from "@/components/Common/OptionListDialog/OptionListDialog.vue";
import ColorPickerButton from "@/components/Common/ColorPickerButton/ColorPickerButton.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import VuePrism from "vue-prism";
import "prismjs/themes/prism-okaidia.min.css";
import { getKisDefectWidgetHTML } from "@/helpers/kisHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import {
  getCoordinatesByAddress,
  initGlobalCopyToClipboard,
  escapeHTML
} from "@/helpers/commonHelper";
import { mapOptionDialogConfig } from "@/configuration/formConfigurations";
import _ from "lodash";
export default {
  name: "KisApiKeyEditView",
  props: ["apiKey"],
  components: {
    LocationMap,
    OptionListDialog,
    ColorPickerButton,
    LogOverview,
    VuePrism
  },
  data: () => ({
    locationDialog: false,
    apiKeyPermissions: [
      { value: "edit", title: "Bearbeiten" },
      { value: "view", title: "Sehen" },
      { value: "none", title: "Keine" }
    ],
    countryArray: [
      { code: "de", label: "Deutschland" },
      { code: "at", label: "Österreich" },
      { code: "ch", label: "Schweiz" },
      { code: "fr", label: "Frankreich" },
      { code: "nl", label: "Niederlande" },
      { code: "be", label: "Belgien" },
      { code: "lu", label: "Luxemburg" },
      { code: "cz", label: "Tschechische Republik" },
      { code: "pl", label: "Polen" },
      { code: "dk", label: "Dänemark" }
    ],
    address: {
      zip: "",
      city: "",
      address: "",
      country_code: "de"
    },
    showIframePreview: {
      defectWidget: 0
    },
    refreshIframePreview: {
      defectWidget: 0
    }
  }),
  async mounted() {
    await this.$store.dispatch("getAllUsers");
    this.initGlobalCopyToClipboard();
  },
  methods: {
    getKisDefectWidgetHTML,
    initGlobalCopyToClipboard,
    escapeHTML,
    updateGeoPosition(geo, item) {
      const { lat, lng } = geo;
      item.defaultGeoLocation = { lat, lng };
      if (this.locationDialog) this.locationDialog = false;
    },
    async getCoordinates() {
      const res = await getCoordinatesByAddress(
        this.address,
        this.$refs.optionDialog,
        mapOptionDialogConfig
      );
      if (res?.status) {
        this.apiKey.defaultGeoLocation = res.geo;
        this.locationDialog = false;
      } else {
        this.snackbarText = res?.message;
        this.snackbar = true;
      }
    },
    setColorAndCodePreview(colorKey, colorValue) {
      if (colorKey && colorValue) {
        this.$set(this.apiKey.color, colorKey, colorValue);
      }
      this.$nextTick(() => {
        this.$forceUpdate();
        this.setCodePreview();
      });
    },
    setCodePreview: _.debounce(function() {
      const codePreviewContainers = document.querySelectorAll(
        ".widget-code-preview"
      );
      if (!codePreviewContainers?.length) {
        return;
      }
      Array.from(codePreviewContainers).forEach(codePreviewContainer => {
        const codePreviewElement = codePreviewContainer.querySelector("pre");
        const codePreviewFor =
          codePreviewContainer.attributes["data-code-preview-for"].value;

        let innerHTML;
        switch (codePreviewFor) {
          case "defect-widget":
            innerHTML = this.getKisDefectWidgetHTML(this.apiKey);
            break;
          case "iframe-defect-widget":
            innerHTML = this.getIframeHTML();
            this.refreshIframePreview.defectWidget++;
            break;
          default:
            throw new Error("can not set code preview");
        }

        if (codePreviewElement) {
          codePreviewElement.remove();
        }
        codePreviewContainer.lastChild.innerHTML = this.getPreviewOuterHTML(
          innerHTML
        );
      });

      window.Prism.highlightAll();
    }, 1000),
    getPreviewOuterHTML(innerHTML) {
      const randomId = (Math.random() + 1).toString(36).substring(7);
      const copyButtonHTML = `<p class="copy-code-preview"
      onClick="copyCodePreviewToClipboard('${randomId}');"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z"/></svg>
        <span>Kopieren</span>
      </p>`;
      return `${copyButtonHTML}<pre class="language-markup" id="${randomId}"><code>${this.escapeHTML(
        innerHTML
      )}</code></pre>`;
    },
    getParamsForIframeSrc() {
      let c = "?";
      const paramsObj = {
        apiKey: this.apiKey.apiKey,
        ...this.apiKey.color
      };
      let params = "";
      for (const [key, value] of Object.entries(paramsObj)) {
        params += `${c}${key}=${encodeURIComponent(value)}`;
        c = "&";
      }
      return params;
    },
    getIframeHTML() {
      return `<iframe src="${this.getIframeSrc()}"></iframe>`;
    },
    getIframeSrc() {
      return `${env.kis_defect_widget_api_url}${this.getParamsForIframeSrc()}`;
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isReadOnly() {
      if (this.isAdmin) {
        return false;
      }
      if (this.apiKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    defaultGeoLocation: {
      get() {
        return (
          this.apiKey.defaultGeoLocation ?? {
            lng: 10.221301500000001,
            lat: 47.55488625
          }
        );
      },
      set(value) {
        this.apiKey.defaultGeoLocation = value;
      }
    },
    users() {
      return this.$store.state.users;
    },
    // Update computed property only when 'refreshIframePreview' is increased in debounced function 'setCodePreview'
    // as to not reload the iframe for every single color change (e.g. by selecting a color via the color-picker canvas).
    iframeSrcDefectWidgetDebounced() {
      if (++this.refreshIframePreview.defectWidget) {
        return this.getIframeSrc("/", this.apiKey);
      }
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.apiKey._id}`;
    }
  }
};
